import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement(React.Fragment, null,
    React.createElement("rect", { x: "1.5", y: "1.5", width: "21", height: "21", rx: "10.5", stroke: "inherit", fill: "inherit" }),
    React.createElement("rect", { x: "7", y: "7", width: "10", height: "10", rx: "5", fill: "currentColor", stroke: "transparent" })));
export default createSvgIcon(iconPath, "RadioButtonChecked");
//# sourceMappingURL=RadioButtonCheckedIcon.js.map